const DEFAULT_WIDTH = 32,
  DEFAULT_HEIGHT = 30,
  CHAR_SIZE_W_BORDER_PX_X = 26,
  CHAR_SIZE_W_BORDER_PX_Y = 25.5,
  TOOL_TYPES = ["draw", "select", "rect", "type"],
  BOX_STYLES = [
    { name: "Default", tl: "┌", tr: "┐", bl: "└", br: "┘", horz: "─", vert: "│" },
    { name: "Bold", tl: "┏", tr: "┓", bl: "┗", br: "┛", horz: "━", vert: "┃" },
    { name: "Double", tl: "╔", tr: "╗", bl: "╚", br: "╝", horz: "═", vert: "║" },
    { name: "Empty", tl: " ", tr: " ", bl: " ", br: " ", horz: " ", vert: " " },
  ],
  EXTRA_CHAR_TABLE = [
    "①",
    "②",
    "③",
    "④",
    "⑤",
    "⑥",
    "⑦",
    "⑧",
    "⑨",
    "⑩",
    "⑪",
    "⑫",
    "⑬",
    "⑭",
    "⑮",
    "⑯",
    "⑰",
    "⑱",
    "⑲",
    "⑳",
    "□",
    "▪",
    "▫",
    "▬",
    "▲",
    "▴",
    "▸",
    "►",
    "▼",
    "▾",
    "◂",
    "◄",
    "◊",
    "○",
    "◌",
    "●",
    "◘",
    "◙",
    "ª",
    "º",
    "¿",
    "®",
    "¬",
    "½",
    "¼",
    "¡",
    "«",
    "»",
    "░",
    "▒",
    "▓",
    "│",
    "┤",
    "©",
    "╣",
    "┴",
    "┬",
    "├",
    "┼",
    "╩",
    "╦",
    "╠",
    "╬",
    "¤",
    "ð",
    "█",
    "▄",
    "¦",
    "▀",
    "µ",
    "þ",
    "Þ",
    "¯",
    "´",
    "≡",
    "±",
    "‗",
    "¾",
    "¶",
    "§",
    "÷",
    "¸",
    "°",
    "¨",
    "·",
    "¹",
    "³",
    "²",
    "■",
  ];

export {
  DEFAULT_HEIGHT,
  DEFAULT_WIDTH,
  CHAR_SIZE_W_BORDER_PX_X,
  CHAR_SIZE_W_BORDER_PX_Y,
  TOOL_TYPES,
  BOX_STYLES,
  EXTRA_CHAR_TABLE,
};
